import React, { useState, useEffect, useRef,useContext  } from 'react';
import Navbar from './Navbar';
import { Container, Row, Col } from "react-bootstrap";
import { useNavigate,Link, useLocation  } from 'react-router-dom';
import Loader from '../components/Loader';
import FilterTable from '../components/FilterTable';
import ReactMarkdown from 'react-markdown';
import axios from 'axios';
import { UserContext } from '../contexts/UserContext';
import FeedbackWidget from '../components/FeedbackWidget';
import MarkdownToggleList from '../components/MarkdownToggleList';
import MarketFYTable from '../components/MarketFYTable';
import { CONFIG} from '../config';

const columns = ["Asset", "Tech","Delivery Type","TMS ID","TMS Name"];
const projectEarlycolumns = ["Client Name","Market", "Market Unit / IG ","TMS ID","TMS Name","Closure Reason","Closure Comments"];
const projectEACcolumns = ["Market", "Market Unit / IG ","TMS ID","TMS Name","Challenges"];

const ProjectMyPortfolio = () => {
 // const apiUrl='';
   // const apiUrl = 'https://divapilotfalcon-hdbqdbd4gxccdmdd.eastus-01.azurewebsites.net/projectclosure_retrieval';
    // const apiUrl='https://divadevfalcon.azurewebsites.net/projectclosure_retrieval';
    const apiUrl = CONFIG.REACT_APP_BACKEND_URL+'/projectclosure_retrieval';
    const projectClosureUrl=CONFIG.REACT_APP_PROJECT_CLOSURE;
    const assetDivRef = useRef(null);
    const eacDivRef = useRef(null);
    const [loading, setLoading] = useState(true); 
    const [modalOpen, setModalOpen] = useState(false);
    const [filteredEarlyData, setFilteredEarlyData] = useState([]);
    const [filteredNegData, setFilteredNegData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [openStates, setOpenStates] = useState(Array(5).fill(false));
    const [isExpanded, setIsExpanded] = useState(true);
    const [projectClosure, setProjectClosure] = useState({});
    const [challengesAndMitigations, setChallengesAndMitigations] = useState([]);
    const [showFeedback, setShowFeedback] = useState(true);
    const [error, setError] = useState("");
    const [projectOutcomes, setProjectOutcomes] = useState("");
    const [activeTab, setActiveTab] = useState("tab5");
    const [noData, setNoData] = useState(false);
    const { userId } = useContext(UserContext);
    const [isOpen, setIsOpen] = useState(false);

    const accordionData = [
      { title: 'What are the Top 5 Challenges?', content: 'This is content of Accordion 1' },
      { title: 'What are the lessons learnt for Projects having client Satisfaction issues?', content: 'This is content of Accordion 3' },
      { title: 'What are the Top 5 reasons for Early closure?', content: 'This is content of Accordion 4' },
      { title: 'what are the top 5 challenges for atci led projects?', content: 'This is content of Accordion 4' },
      { title: 'what are the top 5 things that could be done better?', content: 'This is content of Accordion 5' }
    ];


    useEffect(() => {
      if(userId){
        setLoading(true);
        fetchData(); 
      } else {
        setLoading(true);
        setNoData(false);
      }     
      const handleClickOutside = (e) => {
        if (!e.target.closest(".filter-popup") && !e.target.closest(".filter-icon")) {
          setModalOpen(false);
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };      
    }, [userId]);

    useEffect(() => {
      if (activeTab === 'tab4' && assetDivRef.current) {
        assetDivRef.current.scrollIntoView({ behavior: 'smooth' });
      }
      if (activeTab === 'tab2' && eacDivRef.current) {
        eacDivRef.current.scrollIntoView({ behavior: 'smooth' });
      }
    }, [activeTab]);

    const isMarkdownNA = (markdownString,outputString) => {
      if (!markdownString) return false;
    
      const cleaned = markdownString
        .replace(/[*_\-`#>\n\r]/g, '') // remove markdown symbols
        .trim()
        .toUpperCase();
    
      return cleaned === 'NA' ? outputString : markdownString;
    };

    const fetchData = async () => {
      try{ 
        setLoading(true);
      const postData={
        "query": "project closure portfolio all data",
        "query_type": "projectclosure_portfolio",
        "enterprise_id":userId,
        "governingMarket":"",                  
        "governingClientGroup":"",
        "primaryTechnology":"",
        "deliveryType": "",
        "custom_search": "false"
    }
     await axios.post(apiUrl, postData)
     .then(response => {
        console.log('response',response);
        response.data.earlyclosure_context.forEach(item => {
          for (let key in item) {
            console.log('key',key,item);
            if(key==="governingMarket"){
              item['Market']=item["governingMarket"];
            } else if(key==="governingMarketUnit"){
              item['Market Unit / IG ']=item["governingMarketUnit"];
            } else if(key==="reasonForEarlyClosure"){
              item['Closure Comments']=item["reasonForEarlyClosure"];
            } else if(key==="tmsId"){
              item['TMS ID']=item["tmsId"];
            } else if(key==="tmsName"){
              item['TMS Name']=item["tmsName"];            
            } else if(key==="client"){
              item['Client Name']=item["client"];
            } else if(key==="projectClosureReasons"){
              item["Closure Reason"] = item["closureReasonSubCategory"]
                                      ? item["closureReasonMainCategory"] + " - " + item["closureReasonSubCategory"]
                                      : item["closureReasonMainCategory"];
            } 
          }
        });

        response.data.overallcontext.forEach(item => {
          for (let key in item) {
           console.log('key',key,item);
           if(key==="toolsOrAssetsUsed"){
             item['Asset']=item["toolsOrAssetsUsed"];
           } else if(key==="primaryTechnology"){
             item['Tech']=item["primaryTechnology"];
           } else if(key==="deliveryType"){
             item['Delivery Type']=item["deliveryType"];
           } else if(key==="tmsId"){
             item['TMS ID']=item["tmsId"];
           } else if(key==="tmsName"){
             item['TMS Name']=item["tmsName"];
           } 
         }
       });

        response.data.negativeeactaken_context.forEach(item => {
          for (let key in item) {
            console.log('key',key,item);
            if(key==="governingMarket"){
              item['Market']=item["governingMarket"];
            } else if(key==="governingMarketUnit"){
              item['Market Unit / IG ']=item["governingMarketUnit"];
            } else if(key==="reasonForEarlyClosure"){
              item['Reason for early closure']=item["reasonForEarlyClosure"];
            } else if(key==="tmsId"){
              item['TMS ID']=item["tmsId"];
            } else if(key==="tmsName"){
              item['TMS Name']=item["tmsName"];
            }  else if(key==="challengesAndMitigation"){
              let ChallengesDetails='';
              item["challengesAndMitigation"].forEach((ch)=> {
              //  options.forEach((option) => {
                  //newSelected[option] = true;
                  ChallengesDetails='\r\n\n**'+ch.category+'**\r\n\n'+ch.challenges;
                });                
              item['Challenges']=ChallengesDetails;
              }
           // }
          }
        });

        // if(response.data['Accenture Tools / Assets used']) {
        //   const parts = response.data['Accenture Tools / Assets used'].split('\n-');
        //   response.data['Accenture Tools / Assets used']= parts[0] + parts[1]+ parts.slice(2).map(item => ", " + item).join("");
        //   response.data['Accenture Tools / Assets used']=response.data['Accenture Tools / Assets used'].replace(/undefined/g, "").trim()
        // }

        const blocks = response.data['Challenges and Mitigations'].split(/\n(?=\*\*[^\n]+?:\*\*)/g);

        const rows = [];
        let current = null;
      
        blocks.forEach((block) => {
          const trimmed = block.trim();
      
          // Check if this is a type block (not Challenges or Challenge)
          if (/^\*\*[^*]+:\*\*$/.test(trimmed)) {
            const typeName = trimmed.replace(/\*\*|\:\*\*/g, '').trim();
      
            // Save current block if exists
            if (current) rows.push(current);
      
            current = {
              type: typeName,
              Challenges: '',
              Mitigation: '',
            };
          } else if (trimmed.toLowerCase().startsWith('**challenges:**')) {
            const challengeText = trimmed.replace(/^\s*\*\*\s*challenges\s*:\s*\*\*\s*/i, '').trim();
            if (current) current.Challenges = challengeText;
          } else if (trimmed.toLowerCase().startsWith('**mitigation:**')) {
            const solutionText = trimmed.replace(/^\s*\*\*\s*mitigation\s*:\s*\*\*\s*/i, '').trim();
            if (current) current.Mitigation = solutionText;
          } else {
            // If it's a multi-line value (not a heading), append it to the last known field
            if (current) {
              if (!current.Challenges && current.Mitigation) {
                current.challenges += ' ' + trimmed;
              } else if (current.Mitigation) {
                current.Mitigation += ' ' + trimmed;
              }
            }
          }
        });
      
        // Push the last block
        if (current) {
          if(!(isMarkdownNA(current.Challenges,'')==='' && isMarkdownNA(current.Mitigation,'')==='' ))
          rows.push(current);
        }

        console.log('responserow',rows);
        //response.data['Challenges and Mitigations']=rows
        setChallengesAndMitigations(rows);
       
        console.log('response',response.data);

         setProjectClosure(response.data)
         setFilteredData(response.data.overallcontext);
         setFilteredEarlyData(response.data.earlyclosure_context);
         setFilteredNegData(response.data.negativeeactaken_context);
         setNoData(false);
     })
      .catch(error => {
        console.error('Error posting data:', error);
        setError("Failed to fetch data.");
        setNoData(true);
      });    
      
    } catch (err) {
      setError("Failed to fetch data.");
      setNoData(true);
    } finally {
      setLoading(false);
    } 
    }

    const handleScroll = () => {
      if (assetDivRef.current) {
        assetDivRef.current.scrollIntoView({ behavior: 'smooth' });
      }
      if (eacDivRef.current) {
        eacDivRef.current.scrollIntoView({ behavior: 'smooth' });
      }
    };

      const projectOutComeApi= async () => {
            try{
              setLoading(true);        
              console.log('inside fetchData',projectOutcomes);
              if(!projectOutcomes){
              const postData={
                "query": "project closure portfolio all data",
                "query_type": "portfolio_projectoutcome",
                "enterprise_id": userId,
                "governingMarket": '',                  
                "governingClientGroup":'',
                "primaryTechnology":'',
                "deliveryType": '',
                "custom_search": "False"
              } 
            console.log('postData',postData);
            await axios.post(apiUrl, postData)
            .then(response => {
              console.log('projectOutcome',response.data);
              const projectOutcomeJson=response.data;
              const context=projectOutcomeJson['what are the top 5 challenges?'].context;
              if(context.some(item => typeof item === 'object' && item !== null)) {
          const others = context.filter(item => item.category && item.category.toLowerCase() === 'other');
          console.log('others',others);
          const rest = context.filter(item => item.category &&  item.category.toLowerCase() !== 'other');
          console.log('rest',rest);
          response.data['what are the top 5 challenges?'].context = [...rest, ...others]; 
        } else response.data['what are the top 5 challenges?'].context = []; 

          const contextAtci=projectOutcomeJson['what are the top 5 challenges for atci led projects?'].context;
          if(contextAtci.some(item => typeof item === 'object' && item !== null)) {         
          const othersAtci = context.filter(item => item.category && item.category.toLowerCase() === 'other');
          console.log('others',othersAtci);
          const restAtci = contextAtci.filter(item => item.category && item.category.toLowerCase() !== 'other');
          console.log('restAtci',restAtci);
          projectOutcomeJson['what are the top 5 challenges for atci led projects?'].context = [...restAtci, ...othersAtci];
          } else projectOutcomeJson['what are the top 5 challenges for atci led projects?'].context =[];
          
          const summaryEarly=isMarkdownNA(projectOutcomeJson['what are the top 5 reasons for early closure?'].overall_summary,'There are no early closures reported');
          projectOutcomeJson['what are the top 5 reasons for early closure?'].overall_summary=summaryEarly;
          const contextEarly=projectOutcomeJson['what are the top 5 reasons for early closure?'].context;
          if(contextEarly.some(item => typeof item === 'object' && item !== null)) {
          console.log('contextEarly',contextEarly);
          const cleanData = contextEarly
          .map(item => {
            const filteredContext = item.dsg_context.filter(
              ctx => ctx.reasonForEarlyClosure !== "" && ctx.reasonForEarlyClosure !== null
            );
            return filteredContext.length > 0
              ? { ...item, dsg_context: filteredContext }
              : null;
          })
          .filter(Boolean); // remove nulls          
          console.log('cleanData',cleanData);
          projectOutcomeJson['what are the top 5 reasons for early closure?'].context=cleanData;
        } else    projectOutcomeJson['what are the top 5 reasons for early closure?'].context=[];
        
         // projectOutcomeJson['what are the top 5 reasons for early closure?'].context=cleanedEarly;
          
              setProjectOutcomes(projectOutcomeJson)
            })
            .catch(error => {
              console.error('Error posting data:', error);
              setError("Failed to fetch data.");
            });    
          }
            
          } catch (err) {
            setError("Failed to fetch data.");
          } finally {
            setLoading(false);
          } 
           }

    const toggleAccordion = (index) => {
      const newStates = [...openStates];
      newStates[index] = !newStates[index];
      setOpenStates(newStates);
    };
    const expandAll = () => {setOpenStates(Array(accordionData.length).fill(true)); setIsExpanded(false);}
    const collapseAll = () => {setOpenStates(Array(accordionData.length).fill(false)); setIsExpanded(true);}

  return (
    <div className="container">
      <Navbar />      
      <div className='projectHeader' id="projectHeader">
           <span className="projectHeaderTms"> Project Closure Insights for My Portfolio </span>
      </div>
      {!noData &&
      <Container className="totalproject totalClient ">
      {/* Top Section with About & Export Button */}
      <Row className="align-items-center mb-3">
        <Col md={6} id="about">
          {/* <h3>Filter</h3> */}
        </Col>
        <Col md={6} className="text-end">
        {/* <div className="btn-group export-btn" role="group">
          <button type="button" className="btn btn-primary dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
            Export
          </button>
          <ul className="dropdown-menu">
          <li><a className="dropdown-item" href="#" onClick={handlePdfDownload}>PDF</a></li>          
          </ul>
        </div> */}
        </Col>
      </Row>
      <ul className="nav nav-pills mb-3 displayTab" id="pills-tab" role="tablist">
      <li className="nav-item" role="presentation">
      <button className={`nav-link ${activeTab === "tab5" ? "active" : ""}`}
            onClick={() => setActiveTab("tab5")}>Summary</button>
      </li>  
      <li className="nav-item" role="presentation">
      <button className={`nav-link ${activeTab === "tab1" ? "active" : ""}`}
            onClick={() => setActiveTab("tab1")}>Projects that closed early</button>
      </li>
      {/* <li className="nav-item" role="presentation">
      <button className={`nav-link ${activeTab === "tab2" ? "active" : ""}`}
            onClick={() => setActiveTab("tab2")}>Projects with Negative EAC</button>
      </li> */}
      <li className="nav-item" role="presentation">
      <button className={`nav-link ${activeTab === "tab3" ? "active" : ""}`}
            onClick={() => {setActiveTab("tab3");projectOutComeApi();}}>Project Outcomes</button>
      </li>
      <li className="nav-item" role="presentation">
      <button className={`nav-link ${activeTab === "tab4" ? "active" : ""}`}
            onClick={() => {setActiveTab("tab4"); handleScroll();}}>Assets</button>
      </li>
      </ul>
    <div className="tab-content" id="pills-tabContent">
    {activeTab === "tab1" && <FilterTable data={filteredEarlyData} tab={activeTab} columns={projectEarlycolumns} /> }
    {/* {activeTab === "tab2" && <div ref={eacDivRef}><FilterTable data={filteredNegData} tab={activeTab} columns={projectEACcolumns} /> </div>} */}
    {activeTab === "tab4" && <div ref={assetDivRef}><FilterTable data={filteredData} tab={activeTab}  columns={columns} /> </div>}
    {activeTab === "tab3" && 
      <div className="tab-pane fade show active" id="pills-project_outcomes" role="tabpanel" aria-labelledby="pills-project_outcomes-tab">
      <div className="d-inline-flex rounded-pill overflow-hidden border border-1 displayExpandAll" id="displayExpandAll">
      <button
        className={`btn ${!isExpanded ? 'text-white bg-purple' : 'bg-white'} rounded-0`}
        onClick={expandAll}
        style={{ borderRight: '1px solid #ccc' }}
      >
        Expand All
      </button>
      <button
        className={`btn ${isExpanded ? 'text-white bg-purple' : 'bg-white'} rounded-0`}
        onClick={collapseAll}
      >
        Collapse all
      </button>

    </div>
    <div className="accordion accordion-flush">
      {/* {accordionData.map((item, idx) => ( */}
        <div key='0'>
          <div
            className="accordion-item"
            style={{ cursor: 'pointer',border: '0px' }} 
            onClick={() => toggleAccordion('0')}
          >
             <h2 className="accordion-header">
              <button className='accordion-button fw-medium'>
             What are the top 5 challenges?
              </button>
              </h2>
          </div>
          {openStates['0'] && (
            <div className="p-2 border-top">
            <div><ReactMarkdown>{projectOutcomes?.["what are the top 5 challenges?"]?.overall_summary && projectOutcomes["what are the top 5 challenges?"].overall_summary=='NA'?'':projectOutcomes["what are the top 5 challenges?"].overall_summary}</ReactMarkdown></div>
           <div >                
                {projectOutcomes["what are the top 5 challenges?"].context && projectOutcomes["what are the top 5 challenges?"].context.length>0 && projectOutcomes["what are the top 5 challenges?"].context.map((col) => (
                  <div>    {col.category ?             
                  <div className="accordion" id="accordionExample">
      <div className="accordion-item">
        <h2 className="accordion-header" id={'headingOne'+col.category.replace(/ /g, "-")}>
          <button
            className="accordion-button"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target={'#collapseOne'+col.category.replace(/ /g, "-")}
            aria-expanded="true"
            aria-controls={'collapseOne'+col.category.replace(/ /g, "-")}
          >
            {"View challenges for "+col.category}
          </button>
        </h2>
        <div
          id={'collapseOne'+col.category.replace(/ /g, "-")}
          className="accordion-collapse collapse"
          aria-labelledby={'headingOne'+col.category.replace(/ /g, "-")}
          data-bs-parent="#accordionExample"
        >
          <div className="accordion-body">
                     <table class="table smart-table table-striped displaySummary">  
                                 <tr>
                                   <th>Challenges Summary</th>
                                   <th>Mitigation Summary</th>
                            
                                </tr>
                                <tr>
                                <td><MarkdownToggleList markdownText={col.challenges_summary} /></td>  
                                <td><MarkdownToggleList markdownText={col.mitigation_summary} /></td>  
                                </tr>                         
                     </table>
                  <table class="table smart-table table-challenges">  
                                <tr>
                                  <th>Client – TMS name</th>
                                  <th>Base Market</th>
                                  <th>DSG</th>
                                  <th>Challenges</th>
                                  <th>Mitigation</th>
                                </tr>
                                <tbody>
                                {col.category_context.map((c) => (                
                                <tr>
                                  <td>{c.client+' - '+ c.tmsName}</td>
                                  <td>{c.market}</td>
                                  <td>{c.dominantServiceGroup}</td>
                                   <td><MarkdownToggleList markdownText={c.challenges} /></td>  
                                <td><MarkdownToggleList markdownText={c.mitigation} /></td>  
                                </tr>
                                
                            ))}  
                            </tbody>                          
                    </table>
          </div>
        </div>
      </div>

    </div>
                 : ''  } 
                    </div>
                ))}
              
            </div>
            </div>
          )}
        </div>
        <div key='1'>
          <div
            className="accordion-item"
            style={{ cursor: 'pointer',border: '0px' }} 
            onClick={() => toggleAccordion('1')}
          >
             <h2 className="accordion-header">
              <button className='accordion-button fw-medium'>
              What are the lessons learnt for projects having client satisfaction issues?
              </button>
              </h2>
          </div>
          {openStates['1'] && (
            <div className="p-2 border-top">
            <div><ReactMarkdown>{projectOutcomes?.["what are the lessons learnt for projects having client satisfaction issues?"]?.overall_summary && projectOutcomes["what are the lessons learnt for projects having client satisfaction issues?"].overall_summary!=='NA'?projectOutcomes["what are the lessons learnt for projects having client satisfaction issues?"].overall_summary:''}</ReactMarkdown> </div>
             <div>
            {projectOutcomes["what are the lessons learnt for projects having client satisfaction issues?"].context && projectOutcomes["what are the lessons learnt for projects having client satisfaction issues?"].context.length>0 && projectOutcomes["what are the lessons learnt for projects having client satisfaction issues?"].context.map((col) => (
              
              <div>    {col.dominantServiceGroup ?               
                  <div className="accordion" id="accordionExample1">
      <div className="accordion-item">
        <h2 className="accordion-header" id={'two'+col.dominantServiceGroup.replace(/ /g, "-")}>
          <button
            className="accordion-button"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target={'#collapseTwo'+col.dominantServiceGroup.replace(/ /g, "-")}
            aria-expanded="true"
            aria-controls={'collapseTwo'+col.dominantServiceGroup.replace(/ /g, "-")}
          >
            {col.dominantServiceGroup}
          </button>
        </h2>
        <div
          id={'collapseTwo'+col.dominantServiceGroup.replace(/ /g, "-")}
          className="accordion-collapse collapse"
          aria-labelledby={'two'+col.dominantServiceGroup.replace(/ /g, "-")}
          data-bs-parent="#accordionExample1"
        >
          <div className="accordion-body">
          <table class="table smart-table table-striped">  
                              
                                <tr>
                                   <td><strong>Summary of Leasson Learnt</strong></td>
                                   </tr><tr>
                                    <td><MarkdownToggleList markdownText={col.dsg_summary} /></td>
                                </tr>                         
                     </table>                    
                  <table class="table smart-table table-challenges">  
                                <tr>
                                  <th>Client – TMS name</th>
                                  <th>Base Market</th>
                                  <th>Reasons For Project Closure</th>
                                </tr>
                                <tbody>
                                {col.dsg_context.map((c) => {
                                  let mitigation='';
                                  let ChallengesDetails='';
                                  c["challengesAndMitigation"].map((ch)=> {
                                        //newSelected[option] = true;
                                        ChallengesDetails='\r\n\n**'+ch.category+'**\r\n\n'+ch.challenges;
                                        mitigation='\r\n\n**'+ch.category+'**\r\n\n'+ch.mitigation;
                                      });            
                                      return (
                                      <tr>
                                  <td>{c.client+' - '+ c.tmsName}</td>
                                  <td>{c.market}</td>
                                  <td><ReactMarkdown>{c.reasonsForProjectClosureComments}</ReactMarkdown></td>
                                </tr> )
                                
                            })}  
                            </tbody>                          
                    </table>
          </div>
        </div>
      </div>

    </div>
                : ''  }  
                    </div>
                ))}
            </div>
            </div>
          )}
        </div>
        <div key='2'>
          <div
            className="accordion-item"
            style={{ cursor: 'pointer',border: '0px' }} 
            onClick={() => toggleAccordion('2')}
          >
             <h2 className="accordion-header">
              <button className='accordion-button fw-medium'>
              What are the top 5 reasons for early closure?
              </button>
              </h2>
          </div>
          {openStates['2'] && (
            <div className="p-2 border-top">
              <div><ReactMarkdown>{projectOutcomes?.["what are the top 5 reasons for early closure?"]?.overall_summary && projectOutcomes["what are the top 5 reasons for early closure?"].overall_summary!=='NA'?projectOutcomes["what are the top 5 reasons for early closure?"].overall_summary:''}</ReactMarkdown> </div>
                          {projectOutcomes["what are the top 5 reasons for early closure?"].context && projectOutcomes["what are the top 5 reasons for early closure?"].context.length>0 && projectOutcomes["what are the top 5 reasons for early closure?"].context.map((col) => (
               <div> {col.dominantServiceGroup ?
            <div className="accordion" id="accordionExample">
      <div className="accordion-item">
        <h2 className="accordion-header" id={'headingthree'+col.dominantServiceGroup.replace(/ /g, "-")}>
          <button
            className="accordion-button"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target={'#collapseThree'+col.dominantServiceGroup.replace(/ /g, "-")}
            aria-expanded="true"
            aria-controls={'collapseThree'+col.dominantServiceGroup.replace(/ /g, "-")}
          >
            {col.dominantServiceGroup}
          </button>
        </h2>
        <div
          id={'collapseThree'+col.dominantServiceGroup.replace(/ /g, "-")}
          className="accordion-collapse collapse"
          aria-labelledby={'headingThree'+col.dominantServiceGroup.replace(/ /g, "-")}
          data-bs-parent="#accordionExample"
        >
          <div className="accordion-body">
                     <table class="table smart-table table-striped">  
                                 <tr>
                                   <th>Summary of Reasons For Early Closure</th> </tr><tr>
                                   <td><MarkdownToggleList markdownText={col.dsg_summary} /></td>
                                </tr>                        
                     </table>
                  <table class="table smart-table table-challenges">  
                                <tr>
                                  <th>Client – TMS name</th>
                                  <th>Base Market</th>
                                  <th>Reason For Early Closure</th>
                                </tr>
                                <tbody>
                                {col.dsg_context.map((c) => {  
                                  let mitigation='';
                                  let ChallengesDetails='';
                                  c["challengesAndMitigation"].map((ch)=> {
                                        //newSelected[option] = true;
                                        ChallengesDetails='\r\n\n**'+ch.category+'**\r\n\n'+ch.challenges;
                                        mitigation='\r\n\n**'+ch.category+'**\r\n\n'+ch.mitigation;
                                      });            
                                      return (              
                                <tr>
                                  <td>{c.client+' - '+ c.tmsName}</td>
                                  <td>{c.market}</td>
                                  <td><ReactMarkdown>{c.reasonsForProjectClosureComments}</ReactMarkdown></td>
                                </tr>
                                
                            )})}  
                            </tbody>                          
                    </table>
          </div>
        </div>
      </div>

    </div>  : ''  } 
    </div>
    ))
    }
    
    
            </div>
         )} 
        </div>
        <div key='3'>
          <div
            className="accordion-item"
            style={{ cursor: 'pointer',border: '0px' }} 
            onClick={() => toggleAccordion('3')}
          >
             <h2 className="accordion-header">
              <button className='accordion-button fw-medium'>
              What are the top 5 challenges for ATCI led projects?
              </button>
              </h2>
          </div>
          {openStates['3'] && (
            <div className="p-2 border-top">
             <div><ReactMarkdown>{projectOutcomes?.[ "what are the top 5 challenges for atci led projects?"]?.overall_summary && projectOutcomes[ "what are the top 5 challenges for atci led projects?"].overall_summary!=='NA'?projectOutcomes[ "what are the top 5 challenges for atci led projects?"].overall_summary:''}</ReactMarkdown> </div>          
                  {projectOutcomes["what are the top 5 challenges for atci led projects?"].context && projectOutcomes["what are the top 5 challenges for atci led projects?"].context.length>0 && projectOutcomes["what are the top 5 challenges for atci led projects?"].context.map((col) => (
                  <div> {col.category ?
                 <div className="accordion" id="accordionExample">
      <div className="accordion-item">
        <h2 className="accordion-header" id={'headingthree'+col.category.replace(/ /g, "-")}>
          <button
            className="accordion-button"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target={'#collapseThree'+col.category.replace(/ /g, "-")}
            aria-expanded="true"
            aria-controls={'collapseThree'+col.category.replace(/ /g, "-")}
          >
            {col.category}
          </button>
        </h2>
        <div
          id={'collapseThree'+col.category.replace(/ /g, "-")}
          className="accordion-collapse collapse"
          aria-labelledby={'headingThree'+col.category.replace(/ /g, "-")}
          data-bs-parent="#accordionExample"
        >
          <div className="accordion-body">
                     <table class="table smart-table table-striped displaySummary">  
                                 <tr>
                                   <th>Challenges Summary</th>
                                   <th>Mitigation Summary</th>
                                </tr>
                                <tr>
                                <td><MarkdownToggleList markdownText={col.challenges_summary} /></td>
                                <td><MarkdownToggleList markdownText={col.mitigation_summary} /></td>
                                </tr>                         
                     </table>
                  <table class="table smart-table table-challenges">  
                                <tr>
                                  <th>Client – TMS name</th>
                                  <th>Base Market</th>
                                  <th>Challenges</th>
                                  <th>Mitigation</th>
                                </tr>
                                <tbody>
                                {col.category_context.map((c) => (  
                                <tr>
                                  <td>{c.client+' - '+ c.tmsName}</td>
                                  <td>{c.market}</td>
                                  <td><MarkdownToggleList markdownText={c.challenges} /></td>
                                  <td><MarkdownToggleList markdownText={c.mitigation} /></td>                               
                                </tr>
                                
                            ))} 
                            </tbody>                          
                    </table>
          </div>
        </div>
      </div>

    </div>   : ''  } 
    </div> 
     ))
    }
            </div>
          )}
        </div>
        <div key='4'>
          <div
            className="accordion-item"
            style={{ cursor: 'pointer',border: '0px' }} 
            onClick={() => toggleAccordion('4')}
          >
             <h2 className="accordion-header">
              <button className='accordion-button fw-medium'>
              What are the top 5 things that could be done better?
              </button>
              </h2>
          </div>
          {openStates['4'] && (
            <div className="p-2 border-top">
            <div><ReactMarkdown>{projectOutcomes?.[ "what are the top 5 things that could be done better?"]?.overall_summary && projectOutcomes[ "what are the top 5 things that could be done better?"].overall_summary!=='NA'?projectOutcomes[ "what are the top 5 things that could be done better?"].overall_summary:''}</ReactMarkdown></div>
            <div>
            {projectOutcomes["what are the top 5 things that could be done better?"].context && projectOutcomes["what are the top 5 things that could be done better?"].context.length>0 && projectOutcomes["what are the top 5 things that could be done better?"].context.map((col) => ( 
              <div> {col.dominantServiceGroup ?
            <div className="accordion" id="accordionExample">
      <div className="accordion-item">
        <h2 className="accordion-header" id={'headingthree'+col.dominantServiceGroup.replace(/ /g, "-")}>
          <button
            className="accordion-button"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target={'#collapseThree'+col.dominantServiceGroup.replace(/ /g, "-")}
            aria-expanded="true"
            aria-controls={'collapseThree'+col.dominantServiceGroup.replace(/ /g, "-")}
          >
            {col.dominantServiceGroup}
          </button>
        </h2>
        <div
          id={'collapseThree'+col.dominantServiceGroup.replace(/ /g, "-")}
          className="accordion-collapse collapse"
          aria-labelledby={'headingThree'+col.dominantServiceGroup.replace(/ /g, "-")}
          data-bs-parent="#accordionExample"
        >
          <div className="accordion-body">
                     <table class="table smart-table table-striped">  
                                 <tr>
                                   <th>Summary of Improvement Areas</th></tr><tr>
                                   <td><ReactMarkdown>{col.dsg_summary}</ReactMarkdown></td>
                                </tr>                        
                     </table>
                  <table class="table smart-table table-challenges">  
                                <tr>
                                  <th>Client – TMS name</th>
                                  <th>Base Market</th>
                                  <th>Project Improvement</th>
                                </tr>
                                <tbody>
                                {col.dsg_context.map((c) => {  
                                  let mitigation='';
                                  let ChallengesDetails='';
                                  c["challengesAndMitigation"].map((ch)=> {
                                        //newSelected[option] = true;
                                        ChallengesDetails='\r\n\n**'+ch.category+'**\r\n\n'+ch.challenges;
                                        mitigation='\r\n\n**'+ch.category+'**\r\n\n'+ch.mitigation;
                                      });            
                                      return (              
                                <tr>
                                  <td>{c.client+' - '+ c.tmsName}</td>
                                  <td>{c.market}</td>
                                  <td><ReactMarkdown>{c.projectImprovement}</ReactMarkdown></td>
                                </tr>
                                
                            )})}  
                            </tbody>                          
                    </table>
          </div>
        </div>
      </div>

    </div>  : ''  } 
    </div>
    ))
    }
            </div>
            </div>
          )}
        </div>

   {/* //   ))} */}
    </div>
   
      </div> }
      {activeTab === "tab5" && 
       <table className="table table-bordered table-striped smart-table DemographicsTable">
       <tbody>
         {projectClosure['roleresponse'] && <><tr>
           <td className='fw-medium'>Market / Market Unit / IG </td> </tr>
           <tr>  <td>{projectClosure['roleresponse']}</td>
         </tr> </>}
         <tr> 
           <td className='fw-medium'>Total # of Projects Closed</td></tr>
           <tr> 
            <td><MarketFYTable data={projectClosure['total projects closed fy']} /></td>
         </tr>
         <tr>
           <td className='fw-medium'>Total # of Projects that had early closure</td>
          </tr>
           {/* <tr>  <td><a className='blueColor' onClick={() => setActiveTab("tab1")}>{projectClosure['Total Projects that had early closure']}</a></td> */}
           <tr> 
           <td>  
            {renderMarketTable(projectClosure['Total Projects that had early closure fy'],isOpen, () => setIsOpen(!isOpen))}
           </td>
         </tr>
         <tr>
           <td className='fw-medium'>Accenture Tools / Assets used</td> </tr>
           <tr><td>  <div><ReactMarkdown>{projectClosure['Accenture Tools / Assets used']}</ReactMarkdown> <a className='float-start' onClick={() => setActiveTab("tab4")}>For more details click here</a></div>  </td>        
         </tr>
         <tr>
           <td className='fw-medium'>Challenges and Mitigations </td> </tr>
           <tr>  <td>
                <table className="smart-table table-bordered">
                   <thead>
                     <tr>
                       <th>Category</th>
                       <th>Challenges</th>
                       <th>Mitigations</th>
                     </tr>
                   </thead>
                   <tbody>
                     {challengesAndMitigations && challengesAndMitigations.map((row, idx) => (
                       <tr key={idx}>
                         <td>{row.type}</td>
                         <td><MarkdownToggleList markdownText={row.Challenges} /></td>
                         <td><MarkdownToggleList markdownText={row.Mitigation} /></td>
                       </tr>
                     ))}
                   </tbody>
                 </table>
           </td>
         </tr>
         <tr>
           <td className='fw-medium'>Lessons Learnt</td> </tr>
         <tr>  <td><MarkdownToggleList markdownText={projectClosure['Lessons Learnt Recommended']?projectClosure['Lessons Learnt Recommended']:''} /></td>
         </tr>
         {/* <tr>
           <td className='fw-medium'>Total # of Projects that reported Negative EAC</td> </tr>           
           <tr>  <td>{projectClosure['Total Projects that reported –ve EAC']}</td>
           {/* <tr>  <td><a className='blueColor' onClick={() => setActiveTab("tab2")}>{projectClosure['Total Projects that reported –ve EAC']}</a></td> 
         </tr> */}
         <tr>
           <td className='fw-medium'>Reasons for early closure</td> </tr>
           <tr>  <td><MarkdownToggleList markdownText={projectClosure['Reasons for early closure']?projectClosure['Reasons for early closure']:''} /></td>
         </tr>
       </tbody>
     </table>
      }  
      <div className="">
        <div className='datasource'>Source: <a target="_blank" rel="noopener noreferrer" href={projectClosureUrl}>Project Closure</a></div>
        <div className='dataemailsource'>For any help, please write to <a href="mailto:DiVA-Support@accenture.com">DiVA-Support</a></div>
      </div>
      <br/>
      {showFeedback && (<FeedbackWidget moduleName="myportfolio_web" onSubmit={() => setShowFeedback(false)}/>)}
  
      <div className="footerText">Content Generated by Gen AI, limiting accuracy in few cases. Please use at your own discretion.</div>
    </div>   
    </Container>  }
    {noData && <div className='errorClass'><br/>
          <h3>There are no project closure records associated with your name. </h3>
          <p>For further information, please refer to the <a target="_blank" rel="noopener noreferrer" href={projectClosureUrl} >Project Closure</a> details.</p>
          </div>  }
          {loading && <Loader />}       
    </div>
  );
};


const renderMarketTable = (data, isOpen, toggleOpen) => {
  const isValid = (obj) =>
    obj && typeof obj === "object" && !Array.isArray(obj) && Object.keys(obj).length > 0;

  if (!isValid(data)) return <p>No data available</p>;

  const years = Object.keys(data);

  let markets = Array.from(
    new Set(years.flatMap((year) => Object.keys(data[year] || {})))
  ).sort();

  const totalRow = {};
  years.forEach((year) => {
    totalRow[year] = Object.values(data[year] || {}).reduce(
      (sum, v) => sum + (typeof v === "number" ? v : 0),
      0
    );
  });

  const finalTotal = Object.values(totalRow).reduce((a, b) => a + b, 0);

  
  return (
    <div className="accordion" id="marketAccordion1">
      <div className="accordion-item">

        {/* HEADER */}
        <h2 className="accordion-header">
          <button
            className="accordion-button collapsed"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#collapseTwo"
          >
            <span className="d-flex justify-content-between w-100">
              <span>Total # of Projects (Total: {finalTotal})</span>
            </span>
          </button>
        </h2>

        {/* BODY */}
        <div
         id="collapseTwo"
          className="accordion-collapse collapse"
          data-bs-parent="#marketAccordion1"
        >
          <div className="accordion-body">

            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Market</th>
                  {years.map((year) => (
                    <th key={year}>{year}</th>
                  ))}
                </tr>
              </thead>

              <tbody>
                {markets.map((market) => (
                  <tr key={market}>
                    <td>{market}</td>
                    {years.map((year) => (
                      <td key={year + market}>
                        {data?.[year]?.[market] ?? "--"}
                      </td>
                    ))}
                  </tr>
                ))}

                {/* TOTAL ROW */}
                <tr className="fw-bold bg-light">
                  <td>Total</td>
                  {years.map((year) => (
                    <td key={year + "_t"}>{totalRow[year]}</td>
                  ))}
                </tr>
              </tbody>
            </table>

          </div>
        </div>

      </div>
    </div>
  );
};


export default ProjectMyPortfolio;
